import React, { useEffect, useState } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import ChristianDetails from "./ChristianDetails";
import AddChristian from './AddChristian';
import * as XLSX from 'xlsx';
import { FaFileExcel, FaFilter, FaSearch, FaChevronLeft, FaChevronRight, FaEye, FaPlus, FaUsers, FaCheck } from "react-icons/fa";
import { Modal, Checkbox, DatePicker, Drawer, Button, Select, Input, Space, message, Badge, Tooltip } from "antd";
import "../assets/css/custom-checkbox.css";
import dayjs from 'dayjs';
import API_BASE_URL from "../config";

const { RangePicker } = DatePicker;
const { Option } = Select;
const data = language === "en" ? dataEn : dataKin || {};
const allChristianTable = data && data.allChristianTable ? data.allChristianTable : {};

function AllChristian({ onMenuClick }) {
  const [christians, setChristians] = useState([]);
  const [filteredChristians, setFilteredChristians] = useState([]);
  const [selectedPersonId, setSelectedPersonId] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [showAddChristian, setShowAddChristian] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [genderFilter, setGenderFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [nationalId, setNationalId] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [isViewDrawerVisible, setIsViewDrawerVisible] = useState(false);
  const [ageFrom, setAgeFrom] = useState("");
  const [ageTo, setAgeTo] = useState("");
  const [registrationDateRange, setRegistrationDateRange] = useState([]);
  const [jobStatusFilter, setJobStatusFilter] = useState("");
  const [maritalStatusFilter, setMaritalStatusFilter] = useState("");
  const [educationalStatusFilter, setEducationalStatusFilter] = useState("");
  const [battemStatusFilter, setBattemStatusFilter] = useState("");
  const [choirMemberFilter, setChoirMemberFilter] = useState("");
  const [churchRoleFilter, setChurchRoleFilter] = useState("");
  const [choirGroupFilter, setChoirGroupFilter] = useState("");
  const [schoolFilter, setSchoolFilter] = useState("");
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // Default columns for export (common info only)
  const defaultColumns = [
    'full_name',
    'national_id', 
    'phone_number',
    'email',
    'sex',
    'marital_status',
    'district',
    'sector',
    'cell',
    'village',
    'status'
  ];

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const allColumns = [
    `timestamp`, `full_name`, `national_id`, `phone_number`, `email`, `sex`, `date_of_birth`, `education_level`, `field_of_study`, `professional_training`, `baptized`, `date_of_baptism`, `parish_of_baptism`, `godparent_name`, `marital_status`, `spouse_name`, `church_wedding`, `church_wedding_date`, `church_wedding_parish`, `civil_wedding`, `civil_wedding_date`, `death_date`, `widowed_spouse_name`, `divorce_date`, `divorced_spouse_name`, `employed`, `job_description`, `district`, `sector`, `cell`, `village`, `isibo`, `church_roles`, `choir_member`, `choir_group`, `has_children_under_12`, `num_children_under_12`, `num_children_in_kicukiro`, `num_children_outside_kicukiro`, `spouse_prays_in_emrl`, `registered_phone_number`, `comments`, `status`, `studied`, `school`, `gusoma`, `created_at`
  ];
  
  const columnLabels = {
    timestamp: "Registration Date",
    full_name: "Full Names",
    national_id: "National ID",
    phone_number: "Phone Number",
    email: "Email",
    sex: "Gender",
    date_of_birth: "Date of Birth",
    education_level: "Education Level",
    field_of_study: "Field of Study",
    professional_training: "Professional Training",
    baptized: "Baptism Status",
    date_of_baptism: "Baptism Date",
    parish_of_baptism: "Baptism Parish",
    godparent_name: "Godparent Name",
    marital_status: "Marital Status",
    spouse_name: "Spouse Name",
    church_wedding: "Church Wedding?",
    church_wedding_date: "Church Wedding Date",
    church_wedding_parish: "Church Wedding Parish",
    civil_wedding: "Civil Wedding?",
    civil_wedding_date: "Civil Wedding Date",
    death_date: "Death Date",
    widowed_spouse_name: "Widowed Spouse Name",
    divorce_date: "Divorce Date",
    divorced_spouse_name: "Divorced Spouse Name",
    employed: "Employed?",
    job_description: "Job Description",
    district: "District",
    sector: "Sector",
    cell: "Cell",
    village: "Village",
    isibo: "Isibo",
    church_roles: "Church Roles",
    choir_member: "Choir Member?",
    choir_group: "Choir Group",
    has_children_under_12: "Has Children <12?",
    num_children_under_12: "# Children <12",
    num_children_in_kicukiro: "# Children in Kicukiro",
    num_children_outside_kicukiro: "# Children Outside Kicukiro",
    spouse_prays_in_emrl: "Spouse Prays in EMRL?",
    registered_phone_number: "Registered Phone",
    comments: "Comments",
    status: "Status",
    studied: "Studied?",
    school: "School",
    gusoma: "Gusoma",
    created_at: "Registration Date"
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/christian`)
      .then((response) => {
        setChristians(response.data);
        setFilteredChristians(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  // Set default columns on mount
  useEffect(() => {
    setSelectedColumns([...defaultColumns]);
  }, []);

  const toggleColumn = (column) => {
    setSelectedColumns(prev => 
      prev.includes(column) 
        ? prev.filter(c => c !== column) 
        : [...prev, column]
    );
  };

  const selectAllColumns = () => {
    setSelectedColumns([...allColumns]);
  };

  const selectDefaultColumns = () => {
    setSelectedColumns([...defaultColumns]);
  };

  const exportToExcel = () => {
    const filteredData = filteredChristians.map(christian => {
      const obj = {};
      selectedColumns.forEach(col => {
        if (col === 'district' || col === 'sector' || col === 'cell' || col === 'village') {
          obj[col] = christian[col] || 'N/A';
        } else if (col === 'date_of_birth' && christian[col]) {
          obj[col] = christian[col].split('T')[0];
        } else {
          obj[col] = christian[col] || 'N/A';
        }
      });
      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Christians");
    XLSX.writeFile(workbook, `christians_data_${dayjs().format('YYYY-MM-DD')}.xlsx`);
    message.success(`Exported ${filteredData.length} records successfully!`);
  };

  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth || dateOfBirth === '0000-00-00') return null;
    
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  };

  const ExportModal = () => (
    <Modal
      title={
        <div className="flex justify-between items-center">
          <span>Select Columns to Export</span>
          <div className="flex gap-2">
            <Button size="small" onClick={selectDefaultColumns} className="text-[#164e63]">
              Default
            </Button>
            <Button size="small" onClick={selectAllColumns} className="text-[#164e63]">
              Select All
            </Button>
          </div>
        </div>
      }
      open={isExportModalVisible}
      onOk={() => {
        exportToExcel();
        setIsExportModalVisible(false);
      }}
      onCancel={() => setIsExportModalVisible(false)}
      okText="Export"
      cancelText="Cancel"
      width={isMobile ? '95%' : 900}
      okButtonProps={{
        style: { 
          background: '#164e63', 
          borderColor: '#164e63',
        },
      }}
    >
      <div className="mb-4 p-3 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-800">
          <FaCheck className="inline mr-2" />
          Default columns include: Full Name, National ID, Phone, Email, Gender, Marital Status, and Address fields.
          You can add more columns by checking the boxes below.
        </p>
      </div>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)', 
        gap: '10px',
        maxHeight: '450px',
        overflowY: 'auto',
        padding: '4px'
      }}>
        {allColumns.map((column) => (
          <Checkbox
            key={column}
            checked={selectedColumns.includes(column)}
            onChange={() => toggleColumn(column)}
            className="custom-checkbox"
          >
            <span className={defaultColumns.includes(column) ? 'font-medium text-[#164e63]' : ''}>
              {columnLabels[column] || column.replace(/_/g, ' ')}
              {defaultColumns.includes(column) && (
                <Badge count="default" size="small" className="ml-2" style={{ backgroundColor: '#164e63' }} />
              )}
            </span>
          </Checkbox>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          Selected: {selectedColumns.length} of {allColumns.length} columns
        </p>
      </div>
    </Modal>
  );

  const handleRowClick = (christian) => {
    if (isMobile) {
      setSelectedPerson(christian);
      setIsViewDrawerVisible(true);
    } else {
      setSelectedPersonId(christian.id);
      setNationalId(christian.national_id);
    }
  };

  const handleButtonClick = () => {
    setShowAddChristian(prevState => !prevState);
    setSelectedPersonId(null);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilterChange = () => {
    let filtered = christians;

    if (searchTerm) {
      filtered = filtered.filter(christian => 
        Object.values(christian).some(value => 
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    if (genderFilter) filtered = filtered.filter(christian => christian.sex === genderFilter);
    if (statusFilter) filtered = filtered.filter(christian => christian.status === statusFilter);
    if (jobStatusFilter) filtered = filtered.filter(christian => christian.employed === jobStatusFilter);
    if (maritalStatusFilter) filtered = filtered.filter(christian => christian.marital_status === maritalStatusFilter);
    if (educationalStatusFilter) filtered = filtered.filter(christian => christian.education_level === educationalStatusFilter);
    if (battemStatusFilter) filtered = filtered.filter(christian => christian.baptized === battemStatusFilter);
    if (choirMemberFilter) filtered = filtered.filter(christian => christian.choir_member === choirMemberFilter);
    if (churchRoleFilter) filtered = filtered.filter(christian => christian.church_roles === churchRoleFilter);
    if (choirGroupFilter) filtered = filtered.filter(christian => christian.choir_group === choirGroupFilter);
    if (schoolFilter) filtered = filtered.filter(christian => christian.school === schoolFilter);

    if (ageFrom || ageTo) {
      filtered = filtered.filter(christian => {
        const age = calculateAge(christian.date_of_birth);
        if (age === null) return false;
        
        if (ageFrom && ageTo) {
          return age >= parseInt(ageFrom) && age <= parseInt(ageTo);
        } else if (ageFrom) {
          return age >= parseInt(ageFrom);
        } else if (ageTo) {
          return age <= parseInt(ageTo);
        }
        return true;
      });
    }

    if (registrationDateRange && registrationDateRange.length === 2) {
      const startDate = dayjs(registrationDateRange[0]).format('YYYY-MM-DD');
      const endDate = dayjs(registrationDateRange[1]).format('YYYY-MM-DD');
      
      filtered = filtered.filter(christian => {
        if (!christian.timestamp) return false;
        const regDate = christian.timestamp.split('T')[0];
        return regDate >= startDate && regDate <= endDate;
      });
    }

    setFilteredChristians(filtered);
    setCurrentPage(1);
    if (isMobile) setShowFilters(false);
    message.info(`Found ${filtered.length} members`);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setGenderFilter("");
    setStatusFilter("");
    setJobStatusFilter("");
    setMaritalStatusFilter("");
    setEducationalStatusFilter("");
    setBattemStatusFilter("");
    setChoirMemberFilter("");
    setChurchRoleFilter("");
    setChoirGroupFilter("");
    setSchoolFilter("");
    setAgeFrom("");
    setAgeTo("");
    setRegistrationDateRange([]);
    setFilteredChristians(christians);
    setCurrentPage(1);
    if (isMobile) setShowFilters(false);
    message.info("Filters cleared");
  };
  
  const paginateData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = currentPage * itemsPerPage;
    return filteredChristians.slice(startIndex, endIndex);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleItemsPerPageChange = (value) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredChristians.length / itemsPerPage);

  const ViewDrawer = () => (
    <Drawer
      title="Christian Details"
      placement="right"
      onClose={() => setIsViewDrawerVisible(false)}
      open={isViewDrawerVisible}
      width={isMobile ? '100%' : 450}
      bodyStyle={{ padding: '16px' }}
    >
      {selectedPerson && (
        <div className="space-y-4">
          <div className="text-center pb-4 border-b">
            <h2 className="text-xl font-bold text-gray-800">{selectedPerson.full_name}</h2>
            <Badge 
              className="mt-2"
              color={selectedPerson.status === 'Active' ? 'green' : 'red'}
              text={selectedPerson.status}
            />
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2 border-b pb-2">
              <h3 className="font-semibold text-gray-500 text-sm">National ID</h3>
              <p className="font-medium">{selectedPerson.national_id}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-500 text-sm">Phone</h3>
              <p>{selectedPerson.phone_number || 'N/A'}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-500 text-sm">Gender</h3>
              <p>{selectedPerson.sex || 'N/A'}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-500 text-sm">Marital Status</h3>
              <p>{selectedPerson.marital_status || 'N/A'}</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-500 text-sm">Church Role</h3>
              <p className="truncate">{selectedPerson.church_roles || 'N/A'}</p>
            </div>
            <div className="col-span-2">
              <h3 className="font-semibold text-gray-500 text-sm">Address</h3>
              <p>{selectedPerson.district}, {selectedPerson.sector}, {selectedPerson.cell}</p>
            </div>
          </div>
          
          <Button 
            type="primary"
            onClick={() => {
              setIsViewDrawerVisible(false);
              setSelectedPersonId(selectedPerson.id);
              setNationalId(selectedPerson.national_id);
            }}
            className="w-full mt-4 bg-[#164e63]"
          >
            View Full Details
          </Button>
        </div>
      )}
    </Drawer>
  );

  // Mobile Card View
  const MobileCardView = () => (
    <div className="space-y-3">
      {paginateData().map((christian) => (
        <div
          key={christian.id}
          className="bg-white rounded-lg shadow-md p-4 cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => handleRowClick(christian)}
        >
          <div className="flex justify-between items-start mb-3">
            <div className="flex-1">
              <h3 className="font-bold text-lg text-gray-800">{christian.full_name}</h3>
              <p className="text-sm text-gray-500">ID: {christian.national_id}</p>
            </div>
            <Badge 
              color={christian.status === 'Active' ? 'green' : 'red'}
              text={christian.status}
            />
          </div>
          
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div>
              <span className="text-gray-500">Phone:</span>
              <p className="font-medium">{christian.phone_number || 'N/A'}</p>
            </div>
            <div>
              <span className="text-gray-500">Gender:</span>
              <p className="font-medium">{christian.sex}</p>
            </div>
            <div>
              <span className="text-gray-500">Marital:</span>
              <p className="font-medium">{christian.marital_status}</p>
            </div>
            <div>
              <span className="text-gray-500">Role:</span>
              <p className="font-medium truncate">{christian.church_roles || 'N/A'}</p>
            </div>
          </div>
          
          <div className="mt-3 pt-2 border-t border-gray-100">
            <Button 
              size="small"
              icon={<FaEye />}
              onClick={(e) => {
                e.stopPropagation();
                handleRowClick(christian);
              }}
              className="text-[#164e63]"
            >
              Quick View
            </Button>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="content px-3 sm:px-5">
      {!showAddChristian && !selectedPersonId && (
        <div>
          {/* Header with Add Button */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mt-3 sm:mt-0 mb-4">
            <h2 className="text-lg sm:text-xl font-bold text-[#164e63]">
              {data.menu.allChristian}
            </h2>
            <Button
              type="primary"
              icon={<FaPlus />}
              onClick={handleButtonClick}
              className="bg-[#164e63] w-full sm:w-auto"
            >
              Add New Christian
            </Button>
          </div>

          {/* Search and Filter Bar */}
          <div className="mt-4">
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="flex-1 relative">
                <Input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                  placeholder="Search..."
                  prefix={<FaSearch className="text-gray-400" />}
                  allowClear
                  className="w-full"
                />
              </div>
              
              <div className="flex gap-2 flex-wrap">
                <Button 
                  onClick={() => setShowFilters(!showFilters)}
                  icon={<FaFilter />}
                  className="bg-[#164e63] text-white"
                >
                  {showFilters ? "Hide Advanced Search" : "Advanced Search"}
                </Button>
                
                <Button 
                  onClick={handleFilterChange}
                  className="bg-[#164e63] text-white"
                >
                  Apply Filters
                </Button>
                
                <Button 
                  onClick={clearFilters}
                  className="bg-[#5a7021] text-white"
                >
                  Clear Filters
                </Button>
                
                <Button 
                  onClick={() => setIsExportModalVisible(true)}
                  icon={<FaFileExcel />}
                  className="bg-[#217346] text-white"
                >
                  Export
                </Button>
              </div>
            </div>
            
            {/* Advanced Filters - COMPLETE WITH ALL ORIGINAL FILTERS */}
            {showFilters && (
              <div className="mt-3 p-4 bg-gray-50 rounded-lg max-h-[60vh] overflow-y-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {/* Gender Filter */}
                  <select
                    value={genderFilter}
                    onChange={(e) => setGenderFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>

                  {/* Status Filter */}
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>

                  {/* Job Status Filter */}
                  <select
                    value={jobStatusFilter}
                    onChange={(e) => setJobStatusFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Job</option>
                    <option value="Yego">Yes</option>
                    <option value="Oya">No</option>
                  </select>

                  {/* Marital Status Filter */}
                  <select
                    value={maritalStatusFilter}
                    onChange={(e) => setMaritalStatusFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Marital</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Widowed">Widower</option>
                  </select>

                  {/* Educational Status Filter */}
                  <select
                    value={educationalStatusFilter}
                    onChange={(e) => setEducationalStatusFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Educational</option>
                    <option value="No">No</option>
                    <option value="Amashuri abanza">Primary</option>
                    <option value="Amashuri yisumbuye">Secondary</option>
                    <option value="Ikiciro cya 1 cya Kaminuza (A1)">A1</option>
                    <option value="Ikiciro cya 2 cya Kaminuza (A0)">Bachelor</option>
                    <option value="Ikiciro cya 3 cya Kaminuza (Masters)">Masters</option>
                    <option value="PhD">Phd</option>
                  </select>

                  {/* Baptism Status Filter */}
                  <select
                    value={battemStatusFilter}
                    onChange={(e) => setBattemStatusFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Baptem</option>
                    <option value="Yego">Yego</option>
                    <option value="Oya">Oya</option>
                  </select>

                  {/* Choir Member/Team Filter */}
                  <select
                    value={choirMemberFilter}
                    onChange={(e) => setChoirMemberFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Team</option>
                    <option value="Kicukiro">Kicukiro</option>
                    <option value="Kagarama-Niboye">Kagarama-Niboye</option>
                    <option value="Kabeza-Kanombe">Kabeza-Kanombe</option>
                    <option value="Nyarugenge">Nyarugenge</option>
                    <option value="Kimironko">Kimironko</option>
                    <option value="Nyabisindu">Nyabisindu</option>
                    <option value="Gatenga">Gatenga</option>
                    <option value="Kagugu-Batsinda">Kagugu-Batsinda</option>
                    <option value="Kimisagara">Kimisagara</option>
                    <option value="Gatsata-Bweramvura">Gatsata-Bweramvura</option>
                    <option value="Gikondo-Kigarama">Gikondo-Kigarama</option>
                    <option value="Remera">Remera</option>
                    <option value="Kagina">Kagina</option>
                    <option value="Karembure">Karembure</option>
                    <option value="Rwabutenge">Rwabutenge</option>
                    <option value="Nyakabungo">Nyakabungo</option>
                    <option value="Kabuga">Kabuga</option>
                    <option value="Ntatsinda ubarizwamo">Ntatsinda ubarizwamo</option>
                    <option value="Rwanko">Rwanko</option>
                    <option value="Nyirakanamba">Nyirakanamba</option>
                    <option value="Nyabyunyu">Nyabyunyu</option>
                    <option value="Antenne">Antenne</option>
                    <option value="Gatovu">Gatovu</option>
                    <option value="Kiyanja">Kiyanja</option>
                    <option value="Kagasa">Kagasa</option>
                  </select>

                  {/* Church Roles Filter */}
                  <select
                    value={churchRoleFilter}
                    onChange={(e) => setChurchRoleFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Roles</option>
                    <option value="Umujyanama">Umujyanama</option>
                    <option value="Umuririmbyi">Umuririmbyi</option>
                    <option value="Protocol">Protocol</option>
                    <option value="Technic">Technic</option>
                    <option value="Umunyamasengesho">Umunyamasengesho</option>
                    <option value="Umuvugabutumwa">Umuvugabutumwa</option>
                    <option value="Umuyobozi w'itsinda">Umuyobozi w'itsinda</option>
                    <option value="Umupasitori (Pastor)">Umupasitori (Pastor)</option>
                    <option value="Umukirisitu usanzwe">Umukirisitu usanzwe</option>
                  </select>

                  {/* Choir Group Filter */}
                  <select
                    value={choirGroupFilter}
                    onChange={(e) => setChoirGroupFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">Choir</option>
                    <option value="Narada">Narada</option>
                    <option value="Byiringiro">Byiringiro</option>
                    <option value="Fruta Melody">Fruta Melody</option>
                    <option value="Reverence">Reverence</option>
                    <option value="Maranata">Maranata</option>
                    <option value="Ebenezer">Ebenezer</option>
                  </select>

                  {/* School Filter */}
                  <select
                    value={schoolFilter}
                    onChange={(e) => setSchoolFilter(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                  >
                    <option value="">School</option>
                    <option value="Kicukiro">Kicukiro</option>
                    <option value="Kanombe">Kanombe</option>
                    <option value="Gahanga">Gahanga</option>
                  </select>

                  {/* Age Filter Inputs */}
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      value={ageFrom}
                      onChange={(e) => setAgeFrom(e.target.value)}
                      placeholder="Age from"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                      min="0"
                    />
                    <span className="text-sm">to</span>
                    <input
                      type="number"
                      value={ageTo}
                      onChange={(e) => setAgeTo(e.target.value)}
                      placeholder="Age to"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63]"
                      min="0"
                    />
                  </div>

                  {/* Registration Date Range Picker */}
                  <div className="sm:col-span-2 lg:col-span-3">
                    <RangePicker
                      value={registrationDateRange}
                      onChange={(dates) => setRegistrationDateRange(dates)}
                      className="w-full"
                      placeholder={['Start Date', 'End Date']}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Main Content */}
          <div className="intro-y box p-3 sm:p-5 mt-5">
            {/* Items per page selector */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <span className="text-sm">Show:</span>
                <Select 
                  value={itemsPerPage} 
                  onChange={handleItemsPerPageChange}
                  className="w-20"
                  size="small"
                >
                  <Option value={10}>10</Option>
                  <Option value={25}>25</Option>
                  <Option value={50}>50</Option>
                  <Option value={100}>100</Option>
                </Select>
                <span className="text-sm ml-1">entries</span>
              </div>
              <div className="text-sm text-gray-600">
                Total: <span className="font-bold text-[#164e63]">{filteredChristians.length}</span>
              </div>
            </div>
            
            {/* Desktop Table View */}
            {!isMobile && (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="bg-[#ADC2CB]">
                      <th className="px-4 py-3 rounded-l-lg text-left text-xs font-bold text-[#164E63] uppercase">No.</th>
                      <th className="px-4 py-3 text-left text-xs font-bold text-[#164E63] uppercase">Full Name</th>
                      <th className="px-4 py-3 text-left text-xs font-bold text-[#164E63] uppercase">Sex</th>
                      <th className="px-4 py-3 text-left text-xs font-bold text-[#164E63] uppercase">Choir Group</th>
                      <th className="px-4 py-3 text-left text-xs font-bold text-[#164E63] uppercase">Marital</th>
                      <th className="px-4 py-3 rounded-r-lg text-left text-xs font-bold text-[#164E63] uppercase">Ministry</th>
                     </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {paginateData().map((christian, index) => (
                      <tr
                        key={christian.id}
                        onClick={() => handleRowClick(christian)}
                        className="cursor-pointer hover:bg-gray-50 transition-colors"
                      >
                        <td className="px-4 py-3 text-sm">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td className="px-4 py-3 text-sm font-medium">{christian.full_name}</td>
                        <td className="px-4 py-3 text-sm">{christian.sex}</td>
                        <td className="px-4 py-3 text-sm">{christian.district || 'N/A'}</td>
                        <td className="px-4 py-3 text-sm">{christian.marital_status}</td>
                        <td className="px-4 py-3 text-sm">{christian.church_roles || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            
            {/* Mobile Card View */}
            {isMobile && <MobileCardView />}
            
            {/* Pagination */}
            {filteredChristians.length > 0 && (
              <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4">
                <div className="text-sm text-gray-600 order-2 sm:order-1">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, filteredChristians.length)} of {filteredChristians.length} entries
                </div>
                <div className="flex items-center gap-2 order-1 sm:order-2">
                  <Button
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                    icon={<FaChevronLeft />}
                    size="small"
                  >
                    Previous
                  </Button>
                  <span className="text-sm">
                    Page {currentPage} of {totalPages || 1}
                  </span>
                  <Button
                    disabled={currentPage === totalPages || totalPages === 0}
                    onClick={() => handlePageChange(currentPage + 1)}
                    icon={<FaChevronRight />}
                    size="small"
                  >
                    Next
                  </Button>
                </div>
              </div>
            )}
            
            {filteredChristians.length === 0 && (
              <div className="text-center py-8 text-gray-500">
                <FaUsers className="text-4xl mx-auto mb-2 text-gray-300" />
                <p>No members found</p>
              </div>
            )}
          </div>
        </div>
      )}
     
      {showAddChristian && <AddChristian onBack={handleButtonClick} />}
      {selectedPersonId && !showAddChristian && (
        <ChristianDetails id={selectedPersonId} national_id={nationalId} onBack={() => setSelectedPersonId(null)} />
      )}
      
      <ExportModal />
      <ViewDrawer />
    </div>
  );
}

export default AllChristian;